import { render, staticRenderFns } from "./PlansList.vue?vue&type=template&id=14a77418&"
import script from "./PlansList.vue?vue&type=script&lang=ts&"
export * from "./PlansList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports